import React, { useState, useEffect, useRef } from 'react'
import './Document.css'
import { useParams } from 'react-router'
import { useHistory } from 'react-router-dom'
import Spinner from '../../utilities/spinner/Spinner'
import { getBase64, validateFileType } from '../../utilities/fileReader/FileReader'
import PageManager from '../../component/signingTools/page/PageManager'
import ImageManager from '../../component/signingTools/image/ImageManager'
import TextboxManager from '../../component/signingTools/textbox/TextboxManager'
import RecordManager from '../../component/signingTools/record/RecordManager'
import SketchManager from '../../component/signingTools/signature/SketchManager'
import DocumentPreview from '../../component/document/DocumentPreview'
import { Document, Page } from 'react-pdf/dist/entry.webpack'
import { pdfjs } from 'react-pdf'
//svg
import SvgSignature from '../../svgIcons/SvgSignature'
import SvgKeyboard from '../../svgIcons/SvgKeyboard'
import SvgImage from '../../svgIcons/SvgImage'
//Bootstrap
import Button from 'react-bootstrap/Button'
import Modal from 'react-bootstrap/Modal'
//Redux
import {
  getDirectDocument,
  getReadyDocument,
  setPage,
  openSketchModal,
  clearSketch,
  clearImages,
  clearTextboxes,
  setTitle,
} from '../../redux'
import { useDispatch, useSelector } from 'react-redux'

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`

function SignDocumentModal() {
  const INITIAL_VIEWPORT_SCALE = 1.5
  const IMAGE_FORMATS = ['jpg', 'jpeg', 'png']

  const { documentId } = useParams()

  const history = useHistory()

  const [viewportWidth, setViewportWidth] = useState(10)
  const [numPages, setNumPages] = useState(null)
  const [viewportScales, setViewportScales] = useState([1.5])
  const [imageUrl, setImageUrl] = useState()
  const [imageFormat, setImageFormat] = useState()
  const [imageRefresh, doImageRefresh] = useState(0)
  const [isSignature, setIsSignature] = useState(false)
  const [textboxRefresh, doTextboxRefresh] = useState(0)
  const [saveRefresh, doSaveRefresh] = useState(0)
  const [records, setRecords] = useState([])
  const [doneLoading, setDoneLoading] = useState(false)
  const [isPreview, setIsPreview] = useState(false)
  const [state, setState] = useState({
    pageNumber: 1,
    pageHeight: 0,
    originalPageHeight: 0,
    originalPageWidth: 0,
    pageWidth: 0,
    multiplier: 0,
    offsetTop: 0,
    offsetLeft: 0,
  })

  const widthRef = useRef()
  const inputRef = useRef()
  const pageRef = useRef()

  const dispatch = useDispatch()
  const myDocument = useSelector((state) => state.document)

  useEffect(() => {
    dispatch(setTitle('Sign Document'))
    if (myDocument.documents.length > 0) {
      dispatch(getReadyDocument(documentId))
    } else {
      dispatch(getDirectDocument(documentId))
    }
  }, [])

  useEffect(() => {
    dispatch(setPage(state))
  }, [state])

  useEffect(() => {
    updateDisplayResolution()
  }, [viewportScales])

  const handleRecords = (newPage, type, action) => {
    switch (action) {
      case 'increment':
        const index = records.findIndex((record) => record.page === newPage)
        if (index === -1) {
          // if the page is not in the records array
          if (records.length === 0) {
            // if the records array is empty
            setRecords([
              {
                page: newPage,
                image: type === 'image' ? 1 : 0,
                signature: type === 'signature' ? 1 : 0,
                textbox: type === 'textbox' ? 1 : 0,
              },
            ])
          } else {
            // if the records array is not empty
            const newIndex = records.findIndex((record) => record.page > newPage)
            if (newIndex === -1) {
              // if the new page is largest
              setRecords([
                ...records,
                {
                  page: newPage,
                  image: type === 'image' ? 1 : 0,
                  signature: type === 'signature' ? 1 : 0,
                  textbox: type === 'textbox' ? 1 : 0,
                },
              ])
            } else {
              // if the new page is larger than oneof the current pages
              let newRecords = [...records]
              newRecords.splice(
                newIndex,
                0, // insert the obj at the right index
                {
                  page: newPage,
                  image: type === 'image' ? 1 : 0,
                  signature: type === 'signature' ? 1 : 0,
                  textbox: type === 'textbox' ? 1 : 0,
                }
              )
              setRecords(newRecords)
            }
          }
        } else {
          //found the page in the records array
          let newRecords = records.map((record, rIndex) =>
            index === rIndex
              ? {
                  ...record,
                  ...(type === 'image' && { image: record.image + 1 }),
                  ...(type === 'signature' && { signature: record.signature + 1 }),
                  ...(type === 'textbox' && { textbox: record.textbox + 1 }),
                }
              : record
          )
          setRecords(newRecords)
        }
        break
      case 'decrement':
        // let newRecords = [...records]
        const dIndex = records.findIndex((record) => record.page === newPage)
        let newRecords = records.map((record, rIndex) =>
          dIndex === rIndex
            ? {
                ...record,
                ...(type === 'image' && { image: record.image - 1 }),
                ...(type === 'signature' && { signature: record.signature - 1 }),
                ...(type === 'textbox' && { textbox: record.textbox - 1 }),
              }
            : record
        )
        const dRecord = newRecords[dIndex]
        if (dRecord.image === 0 && dRecord.textbox === 0 && dRecord.signature === 0) {
          newRecords.splice(dIndex, 1) // remove the empty object by index
        }
        setRecords(newRecords)
        break

      default:
        console.log('action incorrect')
    }
  }

  const handleOpenSketchModal = () => {
    dispatch(openSketchModal())
  }

  const handleCancel = () => {
    dispatch(clearSketch())
    dispatch(clearImages())
    dispatch(clearTextboxes())
    history.push('/viewDocumentDetails/' + documentId)
  }

  const handleBack = () => {
    dispatch(clearSketch())
    dispatch(clearImages())
    dispatch(clearTextboxes())
    history.push('/')
  }

  const onPageLoadSuccess = (e) => {
    removeTextLayerOffset()
    const node = pageRef.current.ref
    const multiplier = e.originalHeight / e.height
    setState({
      ...state,
      pageHeight: e.height,
      pageWidth: e.width,
      originalPageHeight: e.originalHeight,
      originalPageWidth: e.originalWidth,
      multiplier,
      offsetTop: node.offsetTop,
      offsetLeft: node.offsetLeft,
    })
    setDoneLoading(true)
  }

  const onDocumentLoadSuccess = ({ numPages }) => {
    setNumPages(numPages)
    setViewportWidth((widthRef.current.offsetWidth - 15) / 2)
    setViewportScales(new Array(numPages).fill(INITIAL_VIEWPORT_SCALE))
  }

  const removeTextLayerOffset = () => {
    const textLayers = document.querySelectorAll('.react-pdf__Page__textContent')
    textLayers.forEach((layer) => {
      const { style } = layer
      style.top = '0'
      style.left = '0'
      style.transform = ''
    })
  }

  const updateDisplayResolution = () => {
    if (doneLoading) {
      const pageWidth = pageRef.current.props.width
      const offsetTop = pageRef.current.ref.offsetTop
      const offsetLeft = pageRef.current.ref.offsetLeft
      const multiplier = state.originalPageWidth / pageWidth
      const pageHeight = state.originalPageHeight / multiplier
      setState({
        ...state,
        pageHeight,
        pageWidth,
        multiplier,
        offsetTop,
        offsetLeft,
      })
    }
  }

  const goToSpecificPage = (specificPage) => {
    setState({ ...state, pageNumber: specificPage })
  }

  const handleSubmit = () => {
    doSaveRefresh(saveRefresh + 1)
    setIsPreview(true)
  }

  const onSelectFile = (e) => {
    if (!e.target.files || e.target.files.length === 0) {
      setImageUrl(undefined)
      return
    }
    var selectedFile = e.target.files[0]
    if (validateFileType(selectedFile, IMAGE_FORMATS, setImageFormat)) {
      getBase64(selectedFile)
        .then((base64) => {
          setImageUrl(base64)
          setIsSignature(false)
          doImageRefresh(imageRefresh + 1)
        })
        .catch((error) => {
          console.log('Error', error)
        })
    } else {
      e.target.value = null
      setImageUrl(undefined)
    }
  }

  const addSignature = (trimmedDataURL) => {
    setImageUrl(trimmedDataURL)
    setImageFormat('png')
    setIsSignature(true)
    doImageRefresh(imageRefresh + 1)
  }

  const handleRedirect = () => {
    history.push('/viewDocumentDetails/' + documentId)
  }

  /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  let signDocumentMarkup =
    myDocument.document && !myDocument.notFound ? (
      <>
        <div className='signboard-window ' ref={widthRef}>
          <Document
            file={myDocument.document.editableDoc ? myDocument.document.editableDoc.url : myDocument.document.originalDoc.url}
            onLoadSuccess={onDocumentLoadSuccess}
            loading={<Spinner />}
          >
            <Page
              renderTextLayer={false}
              pageNumber={state.pageNumber}
              width={viewportWidth * viewportScales[state.pageNumber - 1]}
              onLoadSuccess={(e) => onPageLoadSuccess(e)}
              ref={pageRef}
            />
          </Document>
        </div>

        <div className='signing-tool-background'>
          <div className='signing-tool-container'>
            <div className='signing-tool-pageManager'>
              <PageManager
                state={state}
                setState={setState}
                viewportScales={viewportScales}
                setViewportScales={setViewportScales}
                numPages={numPages}
              />
            </div>

            <div className='signing-tool-icon-container'>
              <div className='signature-tool-individual-icon' onClick={() => handleOpenSketchModal()}>
                <SvgSignature />
              </div>
              <div className='signature-tool-individual-icon' onClick={() => doTextboxRefresh(textboxRefresh + 1)}>
                <SvgKeyboard />
              </div>

              <div className='signature-tool-individual-icon' onClick={() => inputRef.current.click()}>
                <input type='file' ref={inputRef} hidden accept='.jpg, .jpeg, .png' onChange={onSelectFile} />
                <SvgImage />
              </div>
            </div>

            <div className='signing-tool-signPad'>
              <SketchManager addSignature={addSignature} />
            </div>

            <div className='signing-tool-recordsManager'>
              <RecordManager records={records} goToSpecificPage={goToSpecificPage} />
            </div>

            <div className='signing-tool-button'>
              <Button variant='success' onClick={handleSubmit} disabled={records.length === 0}>
                Save and Preview
              </Button>
              <Button variant='danger' onClick={handleCancel}>
                Cancel
              </Button>
            </div>
          </div>
        </div>

        <ImageManager
          imageRefresh={imageRefresh}
          saveRefresh={saveRefresh}
          imageUrl={imageUrl}
          pageNumber={state.pageNumber}
          type={imageFormat}
          isSignature={isSignature}
          handleRecords={handleRecords}
        />

        <TextboxManager
          textboxRefresh={textboxRefresh}
          saveRefresh={saveRefresh}
          pageNumber={state.pageNumber}
          handleRecords={handleRecords}
        />

        {isPreview ? (
          <DocumentPreview
            document={myDocument.document}
            close={() => setIsPreview(false)}
            url={myDocument.document.editableDoc ? myDocument.document.editableDoc.url : myDocument.document.originalDoc.url}
          />
        ) : null}

        {/* Blocking Modal */}
        <Modal show={myDocument.document.status === 'Rejected' || myDocument.document.status === 'Expired'} backdrop={'static'}>
          <Modal.Header closeButton={false}>
            {myDocument.document.status === 'Rejected' && <Modal.Title>The document is rejected by other signer.</Modal.Title>}
            {myDocument.document.status === 'Expired' && <Modal.Title>The document is expired by now.</Modal.Title>}
          </Modal.Header>
          <Modal.Body>You will be redirected away from this page.</Modal.Body>
          <Modal.Footer>
            <Button variant='primary' onClick={handleRedirect}>
              Okay
            </Button>
          </Modal.Footer>
        </Modal>
      </>
    ) : (
      <>
        <p>No Such Document</p>
        <Button variant='danger' onClick={handleBack}>
          Back
        </Button>
      </>
    )

  return (
    <div className='signing-modal'>
      <div className='signing-modal-container'>{signDocumentMarkup}</div>
    </div>
  )
}

export default SignDocumentModal
